import { useRecoilValue } from "recoil"
import { keyframes, styled } from "styled-components"
import { langSelector, langState } from "../../../state/langState"
import { Heading2, T1_en, T1_ko, T6 } from "../../../style/constant"


const Content = () => {
  const currentLang = useRecoilValue(langState)
  const Text = useRecoilValue(langSelector)
  return(
    <Container>
      <Title currentLang = {currentLang}>
        {Text.main.title}
      </Title>
      <Desc currentLang = {currentLang}>{Text.main.desc}</Desc>

      <ArrowDown>
        <img src={"/imgs/home/arrowDown.png"} alt = "Arrow to Down" />
      </ArrowDown>
    </Container>
  )
}


export default Content 

interface Props {
  currentLang:boolean;
}

const moving = keyframes`
  0%{
    background:url(/imgs/home/hand.png) no-repeat 100% 100px/671px 100%;
  }
  100%{
    background:url(/imgs/home/hand.png) no-repeat 100% 0/671px 100%;
  }
`

const Container = styled.div`
  position:relative;
  display: flex;
  flex-direction: column;
  /* background:url(/imgs/home/hand.png) no-repeat 100% center/contain; */
  /* background:url(/imgs/home/hand.png) no-repeat 100% px/671px 100%; */
  width:1200px;
  height:988px;
  margin:0 auto;  
  animation:${moving} 1.5s ease;
  animation-fill-mode: forwards;
`


const Title = styled.p<Props>`
  white-space: pre-line;
  background: linear-gradient(#0453FF, #A635FF);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;

  ${props => props.currentLang ? 
  `
    ${T1_ko};
    margin: 262px 0 25px 0;
  `:
  `
    ${T1_en};
    margin: 299px 0 30px 0;
  ` 
  }
`

const Desc = styled.span<Props>`
  border: 2px solid;
  border-radius: 4px;
  border-image: linear-gradient(#7018FF, #4154FF) 1;
  background-image: linear-gradient(#7018FF, #4154FF);
  text-align: center;
  /* background-origin: border-box;
  background-clip: content-box, border-box; */
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;

  ${props => props.currentLang ? 
  `
    ${Heading2};
    padding:15px 0;
    width:278px;
  `:
  `
    ${T6};
    padding:27px 0;
    width:417px;
  ` 
  }
`

const ArrowDown = styled.div`
  position:absolute;
  left:50%;
  transform: translateX(-50%);
  bottom:56px;
  height:40px;
  text-align: center;
  margin-top:266px auto;
  img{
    width:40px;
    height:100%;
  }
`